(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('business-credential', {
                parent: 'entity',
                url: '/business-credential',
                data: {
                    authorities: [],
                    pageTitle: 'BusinessCredentials'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/business-credential/list/business-credential.html',
                        controller: 'BusinessCredentialController',
                        controllerAs: 'vm'
                    }
                },
                ncyBreadcrumb: {
                    label: 'Business Credentials'
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_BUSINESS_CREDENTIAL];

                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_BUSINESS_CREDENTIAL, access);
                }]
            });
    }
})();
